// extracted by css-extract-rspack-plugin
export default {"tabs":"tabs-JehSIV","tabLink":"tabLink-PbYhMK","tab":"tab-wGsWZz","tabList":"tabList-rbCGME","tabPanel":"tabPanel-dUHckF"};